import Messenger from './Messenger.js';

/**
 * Will only send messages to the origin of the parent frame at the time of
 * initialization.
 * It is assumed that if the browser allows the iframe to be loaded,
 * the parent must have passed the frame-ancestor check.
 */
var FmcHost = /** @class */ (function () {
    function FmcHost(options) {
        var _this = this;
        this.messenger = null;
        this.actionQueue = [];
        this.targetOrigins = [];
        this.dispatch = function (action) {
            _this.send(action);
        };
        this.hasValidParent = function () {
            return _this.window.self !== _this.window.top;
        };
        this.setTarget = function () {
            if (!_this.messenger && _this.hasValidParent()) {
                _this.messenger = new Messenger({
                    ownName: 'FMC',
                    targetWindow: _this.window.parent,
                    ownWindow: _this.window.self,
                    targetOrigins: _this.targetOrigins,
                });
            }
            if (_this.messenger) {
                _this.messenger.onReady(_this.onTargetReady);
            }
        };
        this.onTargetReady = function () {
            _this.dispatchQueue();
            _this.messenger && _this.messenger.offReady(_this.onTargetReady);
        };
        this.dispatchQueue = function () {
            _this.actionQueue.forEach(function (action) { return _this.send(action); });
            _this.actionQueue = [];
        };
        this.targetOrigins = options.targetOrigins;
        this.window = options.window || window;
        this.messenger = options.messenger || null;
        this.setTarget();
    }
    FmcHost.prototype.send = function (action) {
        if (this.messenger && this.messenger.isReady) {
            this.messenger.send(action);
        }
        else {
            this.actionQueue.push(action);
        }
    };
    return FmcHost;
}());

export default FmcHost;
